import { ChangeDetectionStrategy, Component, ElementRef, HostListener, OnDestroy, AfterViewInit } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { EventBusClickService } from '@bca-core/services/event-bus.service';

@Component({
  selector: 'ns-dialog',
  templateUrl: 'dialog.component.html',
  styleUrls: ['dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DialogComponent implements AfterViewInit, OnDestroy {
  readonly close = new Subject<void>();
  readonly backdrop = new Subject<void>();
  readonly escapeKey = new Subject<void>();

  disableClose: boolean;
  disableAnimation: boolean;
  disableBackdrop: boolean;
  isIEBrowser = this.isIEBrowserCheck();

  private focusableElements: HTMLElement[];
  private previouslyFocusedElement: HTMLElement;

  constructor(
    private _eventBus: EventBusClickService,
    private _elementRef: ElementRef
  ) {}

  closeDialog(): void {
    this._eventBus.clickClose(true);
    this.close.next();
  }

  closeClicked(): Observable<void> {
    return this.close.asObservable();
  }

  backdropClicked(): Observable<void> {
    return this.backdrop.asObservable();
  }

  escapeKeyPressed(): Observable<void> {
    return this.escapeKey.asObservable();
  }

  @HostListener('document:keydown.escape', ['$event'])
  onEscapeKeydownHandler(): void {
    if (!this.disableClose) {
      this.closeDialog();
    }
    this.escapeKey.next();
  }

  @HostListener('keydown', ['$event'])
  handleTabKey(event: KeyboardEvent): void {
    if (event.key !== 'Tab' || !this.focusableElements?.length) {
      return;
    }
  
    const firstElement = this.focusableElements[0];
    const lastElement = this.focusableElements[this.focusableElements.length - 1];
  
    if (event.shiftKey && document.activeElement === firstElement) {
      event.preventDefault();
      lastElement.focus();
    } else if (!event.shiftKey && document.activeElement === lastElement) {
      event.preventDefault();
      firstElement.focus();
    }
  }

  ngAfterViewInit(): void {
    this.previouslyFocusedElement = document.activeElement as HTMLElement;

    this.focusableElements = Array.from(
      this._elementRef.nativeElement.querySelectorAll(
        'a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])'
      )
    );

    this.focusableElements[0]?.focus();
  }

  ngOnDestroy(): void {
    this.previouslyFocusedElement?.focus();
  }

  isIEBrowserCheck(): boolean {
    const match = navigator.userAgent.search(/(?:MSIE|Trident\/.*; rv:)/);
    let isIE = false;

    if (match !== -1) {
      isIE = true;
    }

    return isIE;
  }
}
